var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suggestion"},[_c('div',{staticClass:"title"},[_c('router-link',{attrs:{"to":_vm.route}},[_vm._v(" "+_vm._s(_vm.title))]),(_vm.comments)?_c('span',[_c('i',{staticClass:"el-icon-chat-round"}),_vm._v(" "+_vm._s(_vm.comments)+" ")]):_vm._e()],1),_c('p',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }